<template>
  <div class="flex flex-col gap-2 overflow-y-auto py-3 px-4">
    <FileItemCard
      v-for="file in files"
      :key="file.id || file.data_url"
      :is-image="file.file_type === 'image' && !imageErrors[file.data_url]"
      :image-src="file.data_url"
      :file-name="fileName(file)"
      :file-size="file.file_size ? formatSize(file.file_size) : ''"
      :extension="getFileExtension(file.data_url)"
      :icon-color-class="getFileIconColor(file.file_type, getFileExtension(file.data_url))"
      @image-error="onImageError(file.data_url)"
    >
      <template #action>
        <a
          :disabled="imageErrors[file.data_url]"
          :href="!imageErrors[file.data_url] && file.data_url"
          target="_blank"
          rel="noreferrer noopener nofollow"
          class="w-11 h-11 flex items-center justify-center button-naked shrink-0 transition-colors"
        >
          <span class="material-symbols-outlined text-[22px]">download</span>
        </a>
      </template>
    </FileItemCard>
    <div
      v-if="!files.length"
      class="flex flex-col items-center justify-center py-8 gap-2 text-center"
    >
      <span class="material-symbols-outlined text-[32px] text-gray-300">
        folder_open
      </span>
      <p class="text-sm text-gray-400">
        {{ $t('CONVERSATION_FILES.EMPTY_STATE') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FileItemCard from 'dashboard/components/widgets/FileItemCard.vue';
import { getFileExtension, getFileIconColor } from 'dashboard/helper/fileUtils';

export default {
  components: { FileItemCard },
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      imageErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      files: 'getConversationFiles',
    }),
  },
  watch: {
    conversationId() {
      this.fetchFileMessages();
    },
  },
  mounted() {
    this.$store.dispatch('fetchFileMessages', this.conversationId);
  },
  methods: {
    getFileExtension,
    getFileIconColor,
    onImageError(url) {
      this.$set(this.imageErrors, url, true);
    },
    fileName(file) {
      if (file.fallback_title) return file.fallback_title;
      if (file.data_url) {
        const raw = file.data_url.split('?')[0];
        const name = raw.substring(raw.lastIndexOf('/') + 1);
        return decodeURIComponent(name) || 'Unknown file';
      }
      return 'Unknown file';
    },
    formatSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    },
  },
};
</script>
